import NavigationTabsSmooth from '@/scripts/Components/Organisms/navigation-tabs-smooth';

const CommunityTopicBar = function CommunityTopicBar() {};
CommunityTopicBar.prototype.init = function init() {
  return {
    components: {
      NavigationTabsSmooth,
    },
    props: {
      selected: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        isExpanded: false,
      };
    },
    computed: {
      isQuestionPostingPage() {
        const currentPathName = window.location.pathname;
        const lastPath = currentPathName.split('/').splice(-1)[0];

        switch (lastPath) {
          case 'add-new-discussion':
          case 'new':
          case 'edit':
            return true;
          default:
            return false;
        }
      },
    },
    mounted() {
    },
  };
};

export default new CommunityTopicBar();
